import * as React from 'react'
import logo from '../../assets/images/logo.png'
import { useDispatch } from 'react-redux'
import { actionCreators } from '../../store/User/actionCreators'

const SignIn: React.FC = () => {
    const dispatch = useDispatch()
    const [login, setLogin] = React.useState('')
    const [password, setPassword] = React.useState('')

    const onLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLogin(e.target.value)
    }

    const onPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
    }

    const onLoginClick = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        dispatch(actionCreators.login(login, password))
    }

    return <>
        <div className="auth-wrapper">
            <div className="auth-content">
                <div className="card">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12">
                            <div className="card-body">
                                <img src={logo} alt="" className="img-fluid mb-4"/>
                                <h4 className="mb-3 f-w-400">Tablica Serwisowa</h4>
                                <form onSubmit={onLoginClick}>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control" placeholder="Login"
                                               onChange={onLoginChange} value={login}/>
                                    </div>
                                    <div className="input-group mb-4">
                                        <input type="password" className="form-control" placeholder="Hasło"
                                               onChange={onPasswordChange} value={password}/>
                                    </div>
                                    <button className="btn btn-block btn-primary mb-4"
                                            disabled={login === '' || password === ''} type="submit">Login
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default SignIn
